__turbopack_context__.v({
  "markdown": "markdown-module__VyZlBa__markdown",
});
